export default function showProjectName(string) {
    let data = string.replace(/_/g, " ");
    return data.charAt(0).toUpperCase() + data.slice(1);
}
